import React, { useEffect, useState, useMemo } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { fetchAllRegions } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { parseData } from "../utils/helper";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
const RegionPicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  allRegions,
  error,
  meta,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    // if (allRegions)
    dispatch(fetchAllRegions());
  }, [dispatch]);
  // }, [allRegions, dispatch]);

  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  const regionData = useSelector(
    (state) => state?.profileReducer?.locationResponseData
  );
  return (
    <FormControl fullWidth>
      <Content>
        <Typography required={required} color="#666666">
          {label} {required ? "*" : ""}
        </Typography>
      </Content>
      <Select
        value={value}
        onChange={handleChange}
        placeholder="Select"
        displayEmpty
        required={required}
        size="small"
        error={meta && meta.touched && meta.error && error}
        {...input}
        {...props}
      >
        <MenuItem disabled value="">
          <em>{t("Select")}</em>
        </MenuItem>
        {regionData &&
          regionData.map((region) => (
            <MenuItem key={region.code} value={region.id}>
              {region.code} {region.name}
            </MenuItem>
          ))}
      </Select>
      {meta && meta.touched && meta.error ? (
        <Typography color="red" fontSize={".8rem"} align={"center"}>
          {error}
        </Typography>
      ) : (
        ""
      )}
    </FormControl>
  );
};

export default RegionPicker;
